import { StorageKeys, StorageTypes } from 'common/constants/storageKeys';
import ErrorUtils from 'utils/error-utils';
import StorageUtils from '@spothero/utils/storage';
export function getGooglePlacesTypes(parkingType = undefined) {
    try {
        if (!parkingType ||
            parkingType === 'airport' ||
            parkingType === 'event' ||
            parkingType === 'event_package') {
            return {};
        }
        const googlePlacesTypes = StorageUtils.get(StorageKeys.SEARCH_GOOGLE_PLACES_TYPE.STORAGE_KEY, StorageTypes.SESSION);
        if (Array.isArray(googlePlacesTypes) && googlePlacesTypes.length > 0) {
            return {
                google_places_type: googlePlacesTypes.map(type => ({
                    value: type,
                })),
            };
        }
        else {
            return {};
        }
    }
    catch (error) {
        ErrorUtils.sendSentryMessage({
            error,
            customErrorMessage: 'Failed to retrieve Google Places types from session storage',
        });
    }
}
